import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
dayjs.extend(timezone)

export function parseISOToLocalDate(isoString: string, tz: string = "Europe/Moscow"): string {
  return dayjs(isoString).tz(tz).format("DD.MM.YYYY HH:mm")
}
